import * as fetcher from '@hydra/utils/fetcher';

export async function getTasksData (searchParams) {
  return fetcher.get('/api/tasks', { searchParams }).json();
}

export async function updateTasksData (params) {
  return fetcher.put('/api/tasks/update', { json: params }).json();
}
